import { Font } from "@react-pdf/renderer";

const loadFontAsBlobUrl = async (url) => {
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Failed to load font: ${url}`);
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};

export const registeredFonts = new Set();
export function isFontRegistered(family) {
  return registeredFonts.has(family);
}

export function getFontOrFallback(family) {
  console.log("registeredFonts", family);
  console.log("registeredFonts.has(family)", registeredFonts.has(family));
  return registeredFonts.has(family) ? family : "Helvetica";
}

export const registerFonts = async () => {
  const fonts = [
    {
      family: "Light",
      url: "/fonts/FiraSans-300.ttf",
    },
    {
      family: "Regular",
      url: "/fonts/FiraSans-400.ttf",
    },
    {
      family: "Medium",
      url: "/fonts/FiraSans-500.ttf",
    },
    {
      family: "SemiBold",
      url: "/fonts/FiraSans-600.ttf",
    },
    {
      family: "Bold",
      url: "/fonts/FiraSans-700.ttf",
    },
  ];

  try {
    await Promise.all(
      fonts.map(async ({ family, url }) => {
        try {
          const blobUrl = await loadFontAsBlobUrl(url);
          Font.register({ family, src: blobUrl });
          registeredFonts.add(family);
        } catch (err) {
          console.warn(
            `⚠️ Font "${family}" konnte nicht geladen werden. Fallback wird verwendet.`
          );
          // Keine Registrierung → automatisch Fallback-Font verwenden im PDF
        }
      })
    );
  } catch (error) {
    console.error("❌ Fehler beim Registrieren von Fonts:", error);
  }
};
